import { Injectable } from '@angular/core';
import { Pagination } from '../pagination/pagination';

@Injectable({
  providedIn: 'root'
})
export class SortingService {

  constructor() { }
  SortColumn(oldColumn: string, newColumn: string, ascending: boolean, pageIndex: number, serachText: string) {
    let pagination = new Pagination();
    if (oldColumn == newColumn) {
      pagination.ascending = !ascending;
      pagination.columnName = oldColumn;
    } else {
      pagination.columnName = newColumn;
      pagination.ascending = ascending;
    }
    pagination.pageIndex = pageIndex;
    pagination.searchText = serachText;
    return pagination;
  }

}
